<template>
  <div style="width:100%">
    <Loading :value="loading"></Loading>
    <!-- RACOURCIS -->
    <v-card>
      <v-card-title style="padding:0px">
        <v-breadcrumbs icons divider="chevron_right">
          <v-breadcrumbs-item
            icons
            router
            :to="item.path"
            v-for="item in racourcis"
            :key="item.text"
            :disabled="item.disabled"
          >
            {{ item.text }}
          </v-breadcrumbs-item>
        </v-breadcrumbs>
      </v-card-title>
    </v-card>
    <br />

    <v-layout row>
      <v-flex sm12>
        <!-- LISTE DES CHANTIERS-->
        <ChantierIndex :userAdmin="userAdmin"  :commis="false"  :listeChantiers="chantiers"></ChantierIndex>
        <!-- LISTE DES CHANTIERS-->
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import ChantierIndex from "@/components/boardChantier/Chantier_index";
import Loading from "@/components/Loading";

export default {
  components: { ChantierIndex, Loading },
  name: "Index_board_Chantier",
  data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      racourcis: [
        { path: "/boardChantier", text: "DashBoard Chantier", disabled: false }
      ],
      userAdmin: false,
      chantiers: []
    };
  },

  methods: {
    loadChantier() {
      this.loading = true;
      let url = "";
      if (this.user.fonction == "Super Administrateur") {
        url = this.domaine + "chantier/liste";
        this.userAdmin = true
      } else {
        url = this.domaine + "chantier/responsable/" + this.user.id;
        this.userAdmin = false
      }

      this.$http.get(url).then(
        response => {
          this.chantiers = response.body.chantier;
          this.loading = false;
        },
        error => {
          this.loading = false;
          this.$message.error("Echec lors du chargement des chantiers");
        }
      );
    }
  },

  mounted() {
    this.loadChantier();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/boardChantier/Index_board_Chantier.vue